import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Work } from './pages/Work';
import { CaseStudy } from './pages/CaseStudy';
import { Speaking } from './pages/Speaking';
import { Investments } from './pages/Investments';
import { Insights } from './pages/Insights';
import { Press } from './pages/Press';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31bs1ff0jszn8">
      <ScrollToTop data-id="element-1" data-mp="31c9tdzg6grpc" />
      <div className="min-h-screen w-full bg-ivory text-charcoal" data-id="element-2" data-mp="31ctetq51dy84">
        <Nav data-id="element-3" data-mp="2wj8f9tnsow6t" />
        <main data-id="element-4" data-mp="2wip5j08ate3v">
          <Routes data-id="element-5" data-mp="2whxd1y9zzwht">
            <Route path="/" element={<Home data-id="element-7" data-mp="28tmdqzjya4vn" />} data-id="element-6" data-mp="28u5y0mx2p5cu" />
            <Route path="/about" element={<About data-id="element-9" data-mp="28s2xva27hvue" />} data-id="element-8" data-mp="28suumo7jhzm9" />
            <Route path="/work" element={<Work data-id="element-11" data-mp="23u9v6r043jyv" />} data-id="element-10" data-mp="23vkuadim43jn" />
            <Route path="/work/:slug" element={<CaseStudy data-id="element-13" data-mp="3ijxo6nd1puib" />} data-id="element-12" data-mp="23v2rey1g2r2r" />
            <Route path="/speaking" element={<Speaking data-id="element-15" data-mp="3ijfthv617oci" />} data-id="element-14" data-mp="3ikqy1x7ax04o" />
            <Route path="/investments" element={<Investments data-id="element-17" data-mp="3mkrefndynled" />} data-id="element-16" data-mp="3ii4qhxkeukmg" />
            <Route path="/insights" element={<Insights data-id="element-19" data-mp="3mj6lg27aoaim" />} data-id="element-18" data-mp="3mjzu58ptda3e" />
            <Route path="/press" element={<Press data-id="element-21" data-mp="3rdkgu4lyihna" />} data-id="element-20" data-mp="3rbrc4uuwm7hx" />
            <Route path="/contact" element={<Contact data-id="element-23" data-mp="5orh0l86u6j" />} data-id="element-22" data-mp="3recedkz46pg7" />
            <Route path="*" element={<Home data-id="element-25" data-mp="5gbv0xpxarn" />} data-id="element-24" data-mp="4wupmfw6qeo" />
          </Routes>
        </main>
        <Footer data-id="element-26" data-mp="2zllduyaeeel5" />
      </div>
    </BrowserRouter>;
}